module.exports = __webpack_public_path__ + "img/banner-hp-mcafee-mobile.edecb7d0.svg";